import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { OperationalDowntime } from './operationalDowntime.types';

export const operationalDowntimePullQueryBuilder = (document: OperationalDowntime) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query operationalDowntimeFeed($lastRequested: DateTime) {
      operationalDowntimeFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};
